import { show } from 'components/styles/keyframes';
import { device } from 'components/styles/MediaQuery';
import styled, { css } from 'styled-components/macro';

interface ScBackgroundProps {
  $image?: string;
  $loading: boolean;
  deskPositionX?: string;
  mobSize?: string;
  deskSize?: string;
  mobPositionX?: string;
}

export const ScBackground = styled.div<ScBackgroundProps>`
  animation: ${show} 0.6s ease;
  position: absolute;
  top: 0;
  right: 0;
  left: 184px;
  bottom: 0;
  z-index: -1;
  opacity: ${({ $loading }) => ($loading ? '0' : '1')};

  ${({ $image, mobSize, deskPositionX, deskSize, mobPositionX }) =>
    $image &&
    css`
      div {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url(${$image});
        background-position: center top;
        background-repeat: no-repeat;
        background-size: 100% auto;

        @media (${device.desktop}) {
          background-size: ${deskSize || 'auto 288px'};
          background-position: ${deskPositionX} top;
        }

        @media (${device.mobileS}) {
          background-size: ${mobSize || 'auto 204px'};
          background-position: ${mobPositionX} top;
        }
      }
    `}
  @media (${device.mobile}) {
    left: 0;
  }
`;
